const fetchConfig = process.env.FETCH_ENV;

export const IsMock = true; // fetchConfig.isMock;

export const ApiHead = fetchConfig.fetchUrl || [];

// export const MockHead = fetchConfig.mockUrl || [];

// export const DefaultMockHead = MockHead[0];

// export const DefaultApiHead = ApiHead[0];

export const DefaultApiHead = `${fetchConfig.fetchUrl}/mbp-merchant-gateway/mbp-merchant-porter`;

export const DefaultMockHead = `${location.protocol}//${location.hostname}:8888`;



// WEBPACK FOOTER //
// ./src/service/fetchEnv.js